import campaignsList from './actions/campaignsList';
import createCampaign from './actions/createCampaign';
import getCampaign from './actions/getCampaign';
import updateCampaign from './actions/updateCampaign';
import getCampaigns from './getters/getCampaigns';
import uploadCampaigns from './mutations/uploadCampaigns';

const actions = {
    campaignsList,
    getCampaign,
    createCampaign,
    updateCampaign
};

const mutations = {
    uploadCampaigns
};

const getters = {
    getCampaigns
};

export default { actions, mutations, getters };
